import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { getStoreBuilder } from 'vuex-typex';
import { RootState } from './state';
import { Environment } from '@/types';

Vue.use(Vuex);

const store: Store<RootState> = getStoreBuilder<RootState>().vuexStore({ strict: process.env.NODE_ENV === Environment.Production });

export default store;